module.exports = fox._r("fonts/mc-icons-webfont.ttf", __webpack_public_path__ + "_/_/_/common/frame/fonts/1lHMIf7.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/mc-icons-webfont.ttf
// module id = 145
// module chunks = 2